// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* On desktop the layout already bounds the editor height, so the scroller (and
   thus the gutter) fills the full pane down to the status bar. Only cap the
   height on small screens, where the two stacked panes share the viewport. */
@media (max-width: 767.98px) {
  .cm-editor {
    max-height: 50vh;
  }
}

.dropdown-list-item.active-tick a::after {
  font-family: "bootstrap-icons";
  content: "\\f26e"; /* bi-check */
  color: #0d6efd;
  float: right;
}

a .card-body {
  -o-transition: 0.5s;
  -ms-transition: 0.5s;
  -moz-transition: 0.5s;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

a .card-body:hover {
  background-color: #f8f9fa;
}

/* Center the icon in the circular buttons; Bootstrap's asymmetric button
   padding otherwise pushes the icon slightly off-center. */
.button-circle {
  width: 2rem;
  height: 2rem;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Spin the run button's progress icon while a request is in flight. */
.spin {
  display: inline-block;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./Public/css/common.css"],"names":[],"mappings":"AAAA;;6EAE6E;AAC7E;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB,EAAE,aAAa;EAC/B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;2DAC2D;AAC3D;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sEAAsE;AACtE;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* On desktop the layout already bounds the editor height, so the scroller (and\n   thus the gutter) fills the full pane down to the status bar. Only cap the\n   height on small screens, where the two stacked panes share the viewport. */\n@media (max-width: 767.98px) {\n  .cm-editor {\n    max-height: 50vh;\n  }\n}\n\n.dropdown-list-item.active-tick a::after {\n  font-family: \"bootstrap-icons\";\n  content: \"\\f26e\"; /* bi-check */\n  color: #0d6efd;\n  float: right;\n}\n\na .card-body {\n  -o-transition: 0.5s;\n  -ms-transition: 0.5s;\n  -moz-transition: 0.5s;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\na .card-body:hover {\n  background-color: #f8f9fa;\n}\n\n/* Center the icon in the circular buttons; Bootstrap's asymmetric button\n   padding otherwise pushes the icon slightly off-center. */\n.button-circle {\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Spin the run button's progress icon while a request is in flight. */\n.spin {\n  display: inline-block;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
